

import { useContext } from "react";
import Breadcrumb from "../components/Breadcrumb";
import CurrencyView from "../components/CurrencyView";
import { ConfigContext } from "../context/GlobalContext";
import MasterLayout from "../masterLayout/MasterLayout";
import { Languages } from "../Utils/Languages";

export default function CurrencyPage() {
  const { state } = useContext(ConfigContext);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title={Languages[state?.LANGUAGE]?.currency} />
        <CurrencyView />
      </MasterLayout>
    </>
  );
}
